<template>
  <div class="entry">
    <van-tabs v-model="activeName">
      <van-tab v-for="type in typeList" :key="type.id" :title="type.categoryName" :name="type.id"> </van-tab>
    </van-tabs>
    <router-view></router-view>
  </div>
</template>

<script>
  import api from '@/api/entry'
  import store from '@/store'

  let typeList = []
  let activeName = 0

  /**
   * todo 拉取分类
   */
  const pagecategory = () => {
    return new Promise((resolve, reject) => {
      api.goodList.pagecategory().then((res) => {
        let { result } = res
        if (Array.isArray(result) && result.length) {
          typeList = result
          activeName = result && result[0].id
          store.dispatch('newsKiosk/updateActionMainType', activeName)
          resolve(result)
        } else {
          reject()
        }
      })
    })
  }

  export default {
    components: {},
    data() {
      return {
        activeName,
        typeList
      }
    },
    beforeRouteEnter(to, from, next) {
      pagecategory()
        .then(() => {
          next()
        })
        .catch((e) => {
          alert(e)
        })
    },
    watch: {
      activeName(newValue) {
        let url = ''
        switch (newValue) {
          case 104:
            url = 'newspapersAndPeriodicals'
            break
          case 105:
            url = 'books'
            break
          case 106:
            url = 'culturalCreation'
            break
        }
        store.dispatch('newsKiosk/updateActionMainType', newValue)
      }
    },
    methods: {}
  }
</script>
